import * as React from 'react';

import { cn } from '@/lib/utils';

type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Komai redesign — flat input: white card, hairline indigo border, indigo focus.
          'flex h-11 w-full rounded-lg border-[1.5px] border-k-line bg-k-card px-3 py-2 text-base text-k-ink transition-colors duration-150 ease-out file:border-0 file:bg-transparent file:text-sm file:font-semibold file:text-brand-indigo placeholder:text-k-ink-faint hover:border-k-line-strong focus:border-brand-indigo focus-visible:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-40 desktop:text-sm',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
